<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="fmt"><span class="bold">Also by Michael Foley</span></p>
<p class="fm"><em class="italic">Britain’s Railway Disasters: Fatal Accidents from the 1830s to the Present Day</em> (Pen and Sword, 2019 &amp; 2013)</p>
<p class="fm"><em class="italic">Essex: Ready for Anything</em> (Sutton Publishing, 2006)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Also.vue?29c347e9